import React, { memo } from 'react';
import Grid from '../../../Utils/Grid/Grid';
import Col from '../../../Utils/Col/Col';

const QuoteTotalTermsAndButtonsLoadingState: React.FC = () => {
  return (
    <div className="w-full">
      <div className="p-10 bg-loading/background-1 space-y-10">
        <div className="flex items-center justify-between border-b border-b-loading/background-2 pb-8">
          <div className="w-24 h-8 rounded-xl bg-loading/background-2" />
          <div className="w-24 h-10 rounded-xl bg-loading/background-2" />
        </div>
        <div className="flex items-start justify-start gap-x-3">
          <div className="w-6 h-6 rounded-default bg-loading/background-2" />
          <div className="w-full space-y-3">
            <div className="w-3/5 h-7 rounded-lg bg-loading/background-2" />
            <div className="space-y-2">
              <div className="w-full h-4 rounded-default bg-loading/background-2" />
              <div className="w-full h-4 rounded-default bg-loading/background-2" />
              <div className="w-4/5 h-4 rounded-default bg-loading/background-2" />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full px-10 py-8 bg-loading/background-2">
        <Grid>
          <Col span={{ sm: 6 }}>
            <div className="w-full h-14 rounded-full bg-loading/background-1" />
          </Col>
          <Col span={{ sm: 6 }}>
            <div className="w-full h-14 rounded-full bg-loading/background-1" />
          </Col>
        </Grid>
      </div>
    </div>
  );
};

export default memo(QuoteTotalTermsAndButtonsLoadingState);
